import React from 'react';
import DrcIconButton from './DrcIconButton';
import DrcIcons from '../Utilities/DrcIcons';
import { withStyles } from '@material-ui/core/styles';

var styles = (theme) => ({
    notSelected: {
        border: 'solid 3px ' + theme.light.secondary,
        height: 50,
        width: 50,
        borderRadius: 25,
        margin: '8px 8px 8px 0',
        padding: 0,
        '&:focus': {
            borderColor: theme.light.secondary
        },
        '& img': {
            width: 25
        }
    },
    selected: {
        borderColor: theme.light.accent.primary + ' !important'
    }
});

class DrcBerryButton extends React.Component {
    handleClick = () => {
        if (!this.props.handleCheckboxChange) {
            return;
        }

        this.props.handleCheckboxChange(!this.props.selected, this.props.berry);
    };

    render() {
        const { style, selected, title, className, disabled, classes, hard, poly, line } = this.props;

        const berry = this.props.berry > 0 && this.props.berry <= 4 ? this.props.berry : null;
        const berryIcon = DrcIcons.GetBerryIcon(berry, false);

        return (
            <DrcIconButton
                className={`${classes.notSelected} ${selected ? classes.selected : null} ${className}`}
                style={{
                    ...style
                }}
                isText
                disabled={!!disabled}
                onClick={this.handleClick}
                title={title}
                noStyle
                hard={hard}
                poly={poly}
                line={line}
            >
                {berryIcon}
            </DrcIconButton>
        );
    }
}

export default withStyles(styles)(DrcBerryButton);
